export default __webpack_public_path__ + "static/media/break27.a39aecc2.jpg";